export enum ApiNamesEnum {
    Cerberus = 'cerberus',
    Huginn = 'huginn',
    Nephilim = 'nephilim',
    Woland = 'woland'
}
